export default "__VITE_ASSET__34ed8912__"